import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const variantGridColumnsTime = () => [
    {
        field: 'sequence',
        headerName: 'ID',
        width: 85,
    },
    {
        field: 'variant',
        headerName: 'Variant',
        hide: false,
        tooltipField: 'variant',
        width: 275,
        wrapText: true,
        autoHeight: true,

    },
    {
        field: 'tasks',
        headerName: apiProvider.getEntityUpper() + 's',
        flex: 1,
        filter: 'agNumberColumnFilter',
        sort: 'desc',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'events',
        headerName: 'Events',
        width: 90,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
        hide: true,
    },
    {
        field: 'steps',
        headerName: 'Steps',
        width: 90,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
        hide: true,
    },
    {
        field: 'perc_total_tasks',
        headerName: '% Work Items',
        width: 95,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
        hide: true,
        },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        width: 95,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
        },
    {
        field: 'total_duration',
        headerName: 'Total Duration',
        width: 130,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
            hide: false,
    },        
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        width: 95,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'loop',
        headerName: 'Loops',
        width: 80,
        hide: true,
    },
    {
        field: 'age',
        headerName: 'Age (Days)',
        width: 80,
        hide: true,
    },
    {
        field: 'min_duration',
        headerName: 'Min Duration',
        width: 100,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'max_duration',
        headerName: 'Max Duration',
        width: 100,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'compliant',
        headerName: 'Compliant',
        width: 95,
        hide: true,
    },
    {
        field: 'automated',
        headerName: 'Automated',
        width: 95,
        hide: true,
    },
    {
        field: 'perc_total_events',
        headerName: '% Total Events',
        width: 115,
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value , decimals: 1 }),
        hide: true,
    },
    {
        field: 'avg_duration_days',
        type: 'rightAligned',
        headerName: 'Avg Duration (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_days',
        type: 'rightAligned',
        headerName: 'Std Deviation (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
        suppressMenu: true,
    },
    {
        field: 'avg_duration_hrs',
        type: 'rightAligned',
        headerName: 'Avg Duration (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_hrs',
        type: 'rightAligned',
        headerName: 'Std Deviation (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'variant_id',
        headerName: 'ID',
        hide: true,
    },
    {
        field: 'selected',
        headerName: 'Selected',
        hide: true,
    },
];
